function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 0H2a2 2 0 00-2 2v4a2 2 0 002 2h18a2 2 0 002-2V2a2 2 0 00-2-2z",
  fill: "#80B1FF",
  fillRule: "nonzero"
});

function SvgImageRatio31(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 8,
    viewBox: "0 0 22 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='22px' height='8px' viewBox='0 0 22 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3EimageRatio_16-9%3C/title%3E %3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='imageRatio_16-9' fill='%2380B1FF' fill-rule='nonzero'%3E %3Cpath d='M20,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,6 C0,7.1045695 0.8954305,8 2,8 L20,8 C21.1045695,8 22,7.1045695 22,6 L22,2 C22,0.8954305 21.1045695,0 20,0 Z' id='Path'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgImageRatio31 as ReactComponent };